import { Controller } from '@hotwired/stimulus'
import { valueMatched } from '../_input_match_utils'

/* controller */

type CustomInputEvent = InputEvent & { target: HTMLTextAreaElement }

export default class extends Controller<HTMLTextAreaElement> {
  static values = {
    forceCase: String,
    match: String
  }

  declare forceCaseValue: string
  declare readonly hasForceCaseValue: boolean
  declare matchValue: string
  declare readonly hasMatchValue: boolean

  connect(): void {
    this.input(null)
  }

  input(e: CustomInputEvent | null): void {
    const textarea = this.element

    // force casing
    if (this.hasForceCaseValue) {
      if (this.forceCaseValue === 'up') {
        textarea.value = textarea.value.toUpperCase()
      } else if (this.forceCaseValue === 'down') {
        textarea.value = textarea.value.toLowerCase()
      }
    }

    if (this.hasMatchValue) {
      textarea.value = valueMatched(textarea.value, this.matchValue ?? null, null, true)
    }
  }
}
